import AddressDisplay from 'common/components/address/AddressDisplay';
import AddressOnlyDisplay from 'common/components/address/AddressOnlyDisplay';
import { phoneFormat } from 'common/helpers/phoneHelper';

const CustomerDetails = (props) => {
  const { clubMembership, customer } = props;
  const { billTo, shipTo } = clubMembership;
  return (
    <div className="c7-order__customer-detail">
      <h4>Customer information</h4>
      <div>
        {clubMembership.orderDeliveryMethod === 'Pickup' && (
          <>
            <span>
              {renderCustomer(customer.data)}
              <strong>Pick Up At</strong>
              <br />
              <AddressOnlyDisplay address={clubMembership.pickupAt} />
            </span>
          </>
        )}
        {clubMembership.orderDeliveryMethod === 'Ship' && (
          <span>
            <strong>Shipping Address</strong>
            <br />
            <AddressDisplay address={shipTo} />
          </span>
        )}
        <span>
          <strong>Billing Address</strong>
          <br />
          <AddressDisplay address={billTo} />
        </span>
      </div>
    </div>
  );
};

export default CustomerDetails;

const renderCustomer = (customer) => {
  if (!customer) {
    return null;
  }
  return (
    <>
      <strong>Pickup By</strong>
      <br />
      <strong>
        {customer.firstName} {customer.lastName}
      </strong>
      <br />
      Phone:{' '}
      {customer.phones &&
        customer.phones[0] &&
        phoneFormat(customer.phones[0].phone, customer.countryCode)}
      <br />
      <br />
    </>
  );
};
